var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.94255 4.00008L7.80449 1.13814C8.06515 0.877482 8.06515 0.456157 7.80449 0.195496C7.54383 -0.0651653 7.1225 -0.0651653 6.86184 0.195496L3.9999 3.05744L1.13796 0.195496C0.877299 -0.0651653 0.455974 -0.0651653 0.195313 0.195496C-0.0653484 0.456157 -0.0653484 0.877482 0.195313 1.13814L3.05725 4.00008L0.195313 6.86202C-0.0653484 7.12269 -0.0653484 7.54401 0.195313 7.80467C0.32531 7.93467 0.495973 8 0.666636 8C0.837299 8 1.00796 7.93467 1.13796 7.80467L3.9999 4.94273L6.86184 7.80467C6.99184 7.93467 7.1625 8 7.33316 8C7.50383 8 7.67449 7.93467 7.80449 7.80467C8.06515 7.54401 8.06515 7.12269 7.80449 6.86202L4.94255 4.00008Z",
    fill: "#C3C4C7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f6e2f04a61a99f8c069de9f845dcb456.svg";
export { ForwardRef as ReactComponent };